<template>
  <div class="wheel-battle-parent-create">
    <wheel-battle-basic-info-form
      v-model="form"
      :rules="rules"
      :show-group="true"
      :editable="true"
      :union-match-id="unionMatchId"
      :match-id="matchId"
    />

    <div class="footer">
      <div class="footer-inner">
        <van-button
          type="primary"
          round
          class="submit-btn"
          :loading="submitting"
          @click="onSubmit"
        >
          提交
        </van-button>
      </div>
      <div class="footer-safe-area" />
    </div>

    <van-overlay :show="showSuccessDialog" :z-index="2000">
      <div class="success-dialog-wrap">
        <div class="success-dialog">
          <div class="dialog-title">提示</div>
          <div class="dialog-message">车轮战创建成功，是否立即前往编辑出赛顺序</div>
          <div class="dialog-actions">
            <div class="dialog-btn dialog-btn-primary" @click="onGoDetail">立即前往</div>
            <div class="dialog-divider" />
            <div class="dialog-btn" @click="onSkipEdit">暂不编辑</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Toast, Overlay } from 'vant'
Vue.use(Button).use(Toast).use(Overlay)

import WheelBattleBasicInfoForm from './components/WheelBattleBasicInfoForm.vue'
import { adminCreateBMMatchWheelBattleParentGame } from '@/api/wheel-battle'
import { buildCreateParentGameParams } from './utils/api-params'

export default {
  name: 'WheelBattleParentCreate',
  components: {
    WheelBattleBasicInfoForm
  },
  data: function () {
    return {
      unionMatchId: '',
      matchId: '',
      form: {
        roundId: '',
        roundLabel: '',
        beginDate: null,
        stadiumName: '',
        pitchId: '',
        pitchName: '',
        groupId: '',
        groupName: '',
        groupTeams: []
      },
      rules: {},
      submitting: false,
      showSuccessDialog: false,
      createdParentId: ''
    }
  },
  mounted: function () {
    this.unionMatchId = this.$route.params.unionMatchId || ''
    this.matchId = this.$route.query.matchId || ''
    var roundId = this.$route.query.roundId || ''
    var roundLabel = this.$route.query.roundLabel || ''
    if (roundId) {
      this.form = Object.assign({}, this.form, {
        roundId: String(roundId),
        roundLabel: roundLabel
      })
    }
  },
  methods: {
    validateForm: function () {
      if (!this.form.beginDate) {
        Toast('请选择时间')
        return false
      }
      if (!this.form.stadiumName || !String(this.form.stadiumName).trim()) {
        Toast('请输入球场')
        return false
      }
      if (!this.form.pitchId) {
        Toast('请选择场地')
        return false
      }
      if (!this.form.groupId) {
        Toast('请选择小组')
        return false
      }
      if (!this.form.groupTeams || !this.form.groupTeams.length) {
        Toast('所选小组暂无球队')
        return false
      }
      if (!this.matchId) {
        Toast('缺少赛事信息')
        return false
      }
      if (!this.form.roundId) {
        Toast('请选择阶段')
        return false
      }
      return true
    },
    onSubmit: function () {
      if (!this.validateForm()) {
        return
      }
      var self = this
      this.submitting = true
      var params = buildCreateParentGameParams({
        matchId: self.matchId,
        form: self.form,
        groupTeams: self.form.groupTeams
      })
      adminCreateBMMatchWheelBattleParentGame(params).then(function (res) {
        self.submitting = false
        if (!res || res.error) {
          return
        }
        if (res.data && res.data.id) {
          self.createdParentId = res.data.id
          self.showSuccessDialog = true
          return
        }
        Toast('创建失败，请稍后重试')
      }).catch(function () {
        self.submitting = false
      })
    },
    onGoDetail: function () {
      this.showSuccessDialog = false
      this.$router.replace({
        path: '/match-manage/wheel-battle/parent-detail/' + this.createdParentId,
        query: {
          unionMatchId: this.unionMatchId,
          matchId: this.matchId,
          tab: 'teams'
        }
      })
    },
    onSkipEdit: function () {
      this.showSuccessDialog = false
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.wheel-battle-parent-create {
  min-height: 100vh;
  background: #f1f1f1;
  padding-bottom: calc(64px + constant(safe-area-inset-bottom));
  padding-bottom: calc(64px + env(safe-area-inset-bottom));
}

.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: #fff;
  box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.06);
}

.footer-inner {
  padding: 12px 16px;
  display: flex;
  justify-content: flex-end;
}

.footer-safe-area {
  height: constant(safe-area-inset-bottom);
  height: env(safe-area-inset-bottom);
}

.submit-btn {
  min-width: 120px;
  height: 40px;
  background: #337ecc;
  border-color: #337ecc;
}

.success-dialog-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 40px;
}

.success-dialog {
  width: 100%;
  max-width: 320px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  text-align: center;
}

.dialog-title {
  padding: 24px 20px 0;
  font-size: 17px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
}

.dialog-message {
  padding: 12px 20px 24px;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

.dialog-actions {
  border-top: 1px solid #ebedf0;
}

.dialog-btn {
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  color: #333;
  background: #fff;

  &:active {
    background: #f2f3f5;
  }
}

.dialog-btn-primary {
  color: #2071b9;
  font-weight: 500;
}

.dialog-divider {
  height: 1px;
  background: #ebedf0;
}
</style>
